
export enum SignatureStatus {
    WAITING_SIGNATURES = "WAITING_SIGNATURES",
    WAITING_APPROVAL = "WAITING_APPROVAL",
    APPROVED = "APPROVED",
    REJECTED = "REJECTED",
    EXPIRED = "EXPIRED",
}

export const SignatureStatusDisplay: Record<SignatureStatus, string> = {
    [SignatureStatus.WAITING_SIGNATURES]: "Waiting Signatures",
    [SignatureStatus.WAITING_APPROVAL]: "Waiting Approval",
    [SignatureStatus.APPROVED]: "Approved",
    [SignatureStatus.REJECTED]: "Rejected",
    [SignatureStatus.EXPIRED]: "Expired",
};

export const formatSignatureStatus = (value?: string | null): string => {
    if (!value) return "";
    return SignatureStatusDisplay[value as SignatureStatus] ?? value;
};
